export default __webpack_public_path__ + "static/media/down.379aae56.svg";